import { Component, OnInit } from '@angular/core';
import { Tile } from 'src/app/submodules/angular-ui-common/base-types';
import { Color } from 'src/app/config/color';
import { CommonIcon, Icon } from 'src/app/submodules/angular-ui-common/icon';
import { TileSetSettings } from 'src/app/submodules/angular-ui-common/tile-set/tile-set.component';
import { NONE_TYPE } from '@angular/compiler';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {

  settings: TileSetSettings = {
    layout: 1,
    spacing: '10px',
    width: '1200px',
    alignment: 'center',
    tileSettings: {
      fontSize: '21px',
      fontColor: 'black',
      border: "none",
      width: '250px',
      height: '160px',
      icon: {
        fontColor: Color.auxiliary,
        size: '60px'
      },
      label: {
        margin: '8px 0 0 0'
      }
    }
  };

  /* OLD
  tiles : Tile[] = [
    { id: 1,
      icon: CommonIcon.checkDecagram,
      label: "Personal training",
    },
    { id: 2, 
      icon: CommonIcon.checkDecagram,
      label: "Chinesiologia e recupero funzionale post infortunio o trauma",
    },
    { id: 3, 
      icon: CommonIcon.checkDecagram,
      label: "Preparazione atletica per sport individuali o di squadra",
    },
    { id: 4, 
      icon: CommonIcon.checkDecagram,
      label: "Dimagrimento",
    },
    { id: 5, 
      icon: CommonIcon.checkDecagram,
      label: "Riprogrammazione posturale",
    },
    { id: 6, 
      icon: CommonIcon.checkDecagram,
      label: "Pilates",
    }
  ]
  */

  tiles : Tile[] = [
    { id: 1,
      icon: CommonIcon.checkDecagram,
      label: "Training one to one",
    },
    { id: 2, 
      icon: CommonIcon.checkDecagram,
      label: "Dimagrimento",
    },
    { id: 3, 
      icon: CommonIcon.checkDecagram,
      label: "Preparazione atletica per sport individuali o di squadra",
    },
    { id: 4, 
      icon: CommonIcon.checkDecagram,
      label: "Preparazione atletica per il tennis",
    },
    { id: 5, 
      icon: CommonIcon.checkDecagram,
      label: "Preparazione atletica per il calcio",
    },
    { id: 6, 
      icon: CommonIcon.checkDecagram,
      label: "Preparazione atletica per il golf",
    },
    { id: 7, 
      icon: CommonIcon.checkDecagram,
      label: "Chinesiologia e recupero funzionale post infortunio o trauma e riprogrammazione posturale",
    }
  ]

  constructor() { }

  ngOnInit(): void {
  }

}
